module.exports = __webpack_public_path__ + "design-tools.37-qVfkM.svg";